/* ============================================================
   MINIMAL CLUB — LP "10 motivos" | carrossel genérico (UGC e Avaliações)

   Genérico via data-attributes (não depende das classes .ugc-* — assim
   dá pra reaproveitar em qualquer carrossel novo da LP, tipo o de
   avaliações):
   - [data-lp-carousel]  -> viewport (raiz de cada instância)
   - [data-lp-track]     -> trilho com overflow-x (os filhos diretos são os cards)
   - [data-lp-prev] / [data-lp-next] -> setas
   Vídeo/mute (.ugc-mute) é específico do carrossel de UGC e simplesmente
   não faz nada nos cards que não têm <video>.

   - suporta mais de uma instância na página (usa data-attribute, não id)
   - não reinicializa o mesmo carrossel duas vezes (data-lp-init)
   - reinicializa no editor de temas (shopify:section:load)
   ============================================================ */
(function () {
  function iniciar(vp) {
    if (!vp || vp.dataset.lpInit === '1') return;
    vp.dataset.lpInit = '1';

    var track = vp.querySelector('[data-lp-track]');
    var cards = track ? [].slice.call(track.children) : [];
    if (!track || !cards.length) return;

    var GAP = parseFloat(getComputedStyle(track).columnGap) || 20;
    function passo() { return cards[0].offsetWidth + GAP; }

    // setas
    var prev = vp.querySelector('[data-lp-prev]');
    var next = vp.querySelector('[data-lp-next]');
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    function nudge(dir) {
      pausar();
      var fim = track.scrollWidth - track.clientWidth;
      var alvo = track.scrollLeft + dir * passo();
      if (alvo > fim - 4) alvo = 0;          // chegou no fim -> volta pro começo
      if (alvo < 0) alvo = fim;
      track.scrollTo({ left: alvo, behavior: 'smooth' });
    }

    // destaca o card mais central
    function marcarAtivo() {
      var meio = track.scrollLeft + track.clientWidth / 2, melhor = null, dist = 1e9;
      cards.forEach(function (c) {
        var cMeio = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cMeio - meio);
        if (d < dist) { dist = d; melhor = c; }
      });
      cards.forEach(function (c) { c.classList.toggle('is-active', c === melhor); });
    }
    track.addEventListener('scroll', marcarAtivo, { passive: true });
    marcarAtivo();

    // só baixa e toca o vídeo quando o card aparece (são alguns MB cada).
    // com preload="none" o play() falha se ainda não há dados -> tenta de novo no loadeddata
    function tocarVideo(v) {
      if (!v) return;
      v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        v.addEventListener('loadeddata', function () { v.play().catch(function () {}); }, { once: true });
        v.load();
      });
    }
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!v) return;
          if (e.isIntersecting) tocarVideo(v); else v.pause();
        });
      }, { threshold: 0.4 });
      cards.forEach(function (c) { obs.observe(c); });
    } else {
      cards.forEach(function (c) { tocarVideo(c.querySelector('video')); });
    }

    // som: só um vídeo com áudio por vez
    cards.forEach(function (c) {
      var v = c.querySelector('video'), b = c.querySelector('.ugc-mute');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        var ligar = v.muted;
        cards.forEach(function (o) {
          var ov = o.querySelector('video'), ob = o.querySelector('.ugc-mute');
          if (!ov || !ob) return;
          ov.muted = true;
          ob.setAttribute('aria-pressed', 'true');
          ob.setAttribute('aria-label', 'Ativar som');
        });
        if (ligar) {
          v.muted = false;
          v.play().catch(function () {});
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('aria-label', 'Desativar som');
        }
      });
    });

    // "passando" sozinho — pausa na interação
    var lento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null, parado = false;
    function nudgeAuto() {
      var fim = track.scrollWidth - track.clientWidth;
      if (fim <= 4) return;                  // não há o que rolar (os cards cabem na tela)
      var alvo = track.scrollLeft + passo();
      track.scrollTo({ left: alvo > fim - 4 ? 0 : alvo, behavior: 'smooth' });
    }
    function tocar() {
      if (!lento && !parado && !timer) timer = setInterval(nudgeAuto, 4500);
    }
    function pausar() { parado = true; clearInterval(timer); timer = null; }
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) {
      vp.addEventListener(e, pausar, { passive: true });
    });
    tocar();
  }

  function iniciarTodos(escopo) {
    var raiz = escopo || document;
    [].slice.call(raiz.querySelectorAll('[data-lp-carousel]')).forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }

  // editor de temas: a seção é recriada ao editar
  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
})();
